import React, { useEffect } from 'react';
import {
	Button,
	OrderList,
} from '../../components/StyledComponents';
import { Page } from '../../components/ui/Page'
import { Body } from '../../components/layout/Body';
import Store from '../../store/Store';

export interface DashboardPageConsumerProps {
	id?: string;
}

export default function DashboardPageConsumer(props: DashboardPageConsumerProps) {
	const [, orders] = Store.use('ordersError', 'orders') as [unknown, Array<{
		orderState: string;
		[key: string]: unknown;
	}>];

	useEffect(() => {
		if (!orders?.length) Store.loadOrders();
	}, []);

	const orderList = Array.isArray(orders) ? orders : [];
	const mapOrder = (order: any) => ({
		name: order.name ?? '',
		orderId: order.orderId ?? '',
		orderState: order.orderState ?? '',
		dateFrom: order.dateFrom ?? '',
		dateTo: order.dateTo ?? '',
		mission: order.mission ?? '',
		price: typeof order.price === 'number' ? order.price : 0,
		...order
	});
	const activeOrders = orderList
		.filter(
			(order) =>
				!order.orderState.includes('COMPLETED') &&
				!order.orderState.includes('CANCELED')
		)
		.map(mapOrder)
		.slice(0, 2);
	const pastOrders = orderList
		.filter(
			(order) =>
				order.orderState.includes('COMPLETED') ||
				order.orderState.includes('CANCELED')
		)
		.map(mapOrder)
		.slice(0, 2);

	console.log('Active orders:', activeOrders);
	console.log('Past orders:', pastOrders);

	const hasActive = activeOrders.length > 0;
	const hasPast = pastOrders.length > 0;

	return (
		<Page id={props.id}>
			<Body>
				<div className="relative w-full min-h-[400px]">
					<div className="relative z-10 mt-10">
						{!hasActive && !hasPast ? (
							<div className="w-full h-[400px] flex flex-col items-center justify-center">
								<img
									src="/assets/dashboard-bg.svg"
									alt="Dashboard Illustration"
									className="max-w-[420px] w-full h-auto mb-6"
								/>
								<p style={{ fontSize: '1.375rem' }} className="text-center">
									Sie haben noch keine Aufträge. :(
								</p>
								<Button className="mt-auto max-w-60" primary onClick={() => Store.startBooking()}>
									Jetzt Drohnenflug buchen!
								</Button>
							</div>
						) : (
							<div>
								<div className="flex w-full gap-6 min-h-[300px]">

									<div className="block items-center justify-center w-1/2">
										<h2 className='text-2xl pb-8'>Aktuelle Aufträge</h2>

										{hasActive ? (
											<OrderList
												data-pw="order-list-active"
												title="Aktuelle Aufträge"
												orders={activeOrders}
												dashboard={true}
											/>
										) : (
											<div className='justify-items-center'>
												<img
													src="/assets/dashboard-bg.svg"
													alt="No active orders"
													className="max-w-[320px] w-full h-auto opacity-70"
												/>
												<p style={{ fontSize: '1.375rem' }} className="text-center py-8">
													Sie haben noch keine Aufträge. :(
												</p>
												<Button className="mt-auto max-w-60" primary onClick={() => Store.startBooking()}>
													Jetzt Drohnenflug buchen!
												</Button>
											</div>


										)}
									</div>

									<div className="block items-center justify-center w-1/2">
										<h2 className='text-2xl pb-8'>Vergangene Aufträge</h2>

										{hasPast ? (
											<OrderList
												data-pw="order-list-past"
												title="Vergangene Aufträge"
												orders={pastOrders}
												dashboard={true}
											/>
										) : (
											<div className='justify-items-center'>
												<img
													src="/assets/dashboard-bg.svg"
													alt="No active orders"
													className="max-w-[320px] w-full h-auto opacity-70"
												/>
												<p style={{ fontSize: '1.375rem' }} className="text-center py-8">
													Sie haben noch keine Aufträge. :(
												</p>
												<Button className="mt-auto max-w-60" primary onClick={() => Store.startBooking()}>
													Jetzt Drohnenflug buchen!
												</Button>
											</div>
										)}
									</div>

								</div>
							</div>

						)}
					</div>
				</div>
			</Body>
		</Page>
	);
}
